export default __webpack_public_path__ + "static/media/solucao-05.91670d79.webp";